import { Search } from "react-feather"
import { Input } from "reactstrap"

const SeachBar = ({ search, setSearch, loading }) => {
    return <div className="search-bar">
        <Input disabled={loading} value={search} onChange={(e) => setSearch(e.target.value)} type="search" placeholder="Search..." className="custom-input" />
        <Search />
    </div>
}

export default SeachBar
